module.exports = "/legacy/67d6ee2e7ca4b345a8a3a04a29ae52c1.svg";